import React, { Component } from "react";

const CloseIcon = ({ width, fill, onClick }) => {
  return (
    <svg
      width={width}
      height={width}
      onClick={onClick}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0834 0L6.02723 3.8413L1.97103 0L0.37793 1.5087L4.43413 5.35L0.37793 9.1913L1.97103 10.7L6.02723 6.8587L10.0834 10.7L11.6765 9.1913L7.62033 5.35L11.6765 1.5087L10.0834 0Z"
        fill={fill}
      />
    </svg>
  );
};

CloseIcon.defaultProps = {
  width: 13,
  fill: "black",
};

export default CloseIcon;
